import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  Chip,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { Edit, Visibility, Delete } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { Snackbar, Alert } from '@mui/material';
import axios from "axios";

const MuiDataTable = ({
  data,
  columns,
  onEdit,
  onView,
  onDelete,
  selectedView,
  searchQuery,
  userRole,
}) => {
  // console.log("role is ", userRole)
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [versioningOpen, setVersioningOpen] = useState(false)
  const [versioningProduct, setVersioningProduct] = useState(null);
  const [versioningId, setVersioningId] = useState(null);
  const [toast, setToast] = React.useState({ open: false, message: '', severity: 'success' });
  const navigate = useNavigate();

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const ConfirmVersiong = async (id) => {
    try{
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/initiate-versioning/${id}`)
      if (response?.status === 200) {
        setToast({ open: true, message: 'Versioning Initiated Successfully.', severity: 'success' });
        // getchProductsDetails();
        setVersioningOpen(false)
        navigate(`/versioning/${id}`)
        
      }
    } catch (err) {
      setToast({ open: true, message: 'Failed to Initiate Versioning.', severity: 'error' });
    }
  }

  const handleDeleteClick = (productId, productName) => {
    setProductToDelete({ id: productId, name: productName });
    setDeleteDialogOpen(true);
  };

  const handleVersioningPopup = (id, name, currentPhase) => {

    if(currentPhase === "In Versioning"){
      // navigate(`/versioning/${id}`)
      window.location.href = `/versioning/${id}`;
    }else{
      setVersioningProduct(name);
      setVersioningId(id);
      setVersioningOpen(true)
    }
   

  }

  const handleDeleteConfirm = () => {
    if (productToDelete && onDelete) {
      onDelete(productToDelete.id);
    }
    setDeleteDialogOpen(false);
    setProductToDelete(null);
  };
  const hanldeVersioning = () => {
    if (versioningId) {
      ConfirmVersiong(versioningId);
    }
    setVersioningOpen(false)
    setVersioningProduct(null);
    setVersioningId(null);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setProductToDelete(null);
  };

  const handleVersioningCancel = () => {
    setVersioningOpen(false);
    setVersioningProduct(null);
    setVersioningId(null);


  }

  const sortedData = React.useMemo(() => {
    if (!orderBy) return data;

    return [...data].sort((a, b) => {
      let aVal = a[orderBy];
      let bVal = b[orderBy];

      // Handle different data types
      if (typeof aVal === "string") {
        aVal = aVal.toLowerCase();
        bVal = bVal.toLowerCase();
      }

      if (typeof aVal === "number") {
        return order === "asc" ? aVal - bVal : bVal - aVal;
      }

      if (order === "asc") {
        return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
      } else {
        return aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
      }
    });
  }, [data, order, orderBy]);

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "product onboarded":
        return "#abf2d3ff";
      case "inactive":
        return "error";
      case "in progress":
        return "#e6dbf2ff";
      case "draft":
        return "info";
      default:
        return "#f6ebf2ff";
    }
  };
   const getTextColor = (status) => {
    switch (status.toLowerCase()) {
      case "product onboarded":
        return "#214838ff";
      case "inactive":
        return "error";
      case "in progress":
        return "#8b36e6ff";
      case "draft":
        return "info";
      default:
        return "#cd0b7fff";
    }
  };


  const getQualityScoreColor = (score) => {
    if (score > 85) return "#4CAF50";
    if (score >= 55) return "#FF9800";
    if (score < 55) return "#F44336";
    return "#000";
  };
console.log("columns name", columns)
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ boxShadow: "none",   }}
        className="font-poppins"
      >
        <Table sx={{ '& tbody .MuiTableCell-root': { borderBottom: 'none' } }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F6F6F6" }}>
              
              {columns.filter(item =>item.id !== "versioning").map((column)  => (
                <TableCell 
                  key={column.id}
                  sx={{
                    width: selectedView === "products" ? 
                      column.id === 'productName' ? '15%' :
                      column.id === 'productDescription' ? '35%' :
                      column.id === 'currentPhase' ? '15%' :
                      column.id === 'status' ? '15%' :
                      column.id === 'actions' ? '10%' : 'auto'
                      : 'auto'
                  }}
                >
                  {column.sortable ? (
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={() => handleRequestSort(column.id)}
                      sx={{ 
                        fontWeight: 600, 
                        fontSize: "12px", 
                        color: "#404040 !important",
                        "&.MuiTableSortLabel-root": {
                          color: "#404040 !important"
                        },
                        "&.MuiTableSortLabel-root.Mui-active": {
                          color: "#404040 !important"
                        },
                        "&.MuiTableSortLabel-root:hover": {
                          color: "#404040 !important"
                        },
                        "& .MuiTableSortLabel-icon": {
                          color: "#404040 !important"
                        }
                      }}
                    >
                      {column.label}
                    </TableSortLabel>
                  ) : (
                    <Box sx={{ fontWeight: 600, fontSize:  "12px", color: "#404040" }}>{column.label}</Box>
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((row, index) => (
              <TableRow
                key={row.id || index}
                sx={{
                  // "&:hover": { backgroundColor: "#f9f9f9" },
                  // "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
                  border: "none",
                  fontSize: "18px"
                }}
              >
                {selectedView === "products" ? (
                  <>
                    <TableCell sx={{ fontWeight: 500, width: '15%',fontSize: '12px !important' }}>
                      {row.productName}
                    </TableCell>
<TableCell
  sx={{
    fontSize: "12px !important",
    whiteSpace: "normal",   // allow wrapping
    overflow: "hidden",
  }}
  title={row.productDescription}
>
  {(() => {
    const words = row.productDescription?.split(/\s+/) || [];
    return words.slice(0, 15).join(" ") + (words.length > 15 ? " ..." : "");
  })()}
</TableCell>

          
                    <TableCell sx={{fontSize: "12px !important"}}><Box sx={{display: "flex", justifyContent : 'center'}}>{row?.version || 1}</Box></TableCell>
                    <TableCell sx={{fontSize: '12px !important'}}>
                     <Chip 
                     label={row.status}
                   size="small"
                  variant="filled"
                sx={{
                backgroundColor: getStatusColor(row.status),
              color: getTextColor(row.status),
            fontSize: '12px !important',
             border: "none",
               padding: "5px 0",   borderRadius: '6px'}}
         />
                    </TableCell>
                    <TableCell sx={{fontSize: "12px !important"}}>{row.currentPhase || "N/A"}</TableCell>
                
                    <TableCell sx={{ width: '10%',fontSize: "12px !important", paddingRight: '20px !important',}}>
                      <Box sx={{ display: "flex", gap: 0.1 }}>
                    

                    
                        
                      {(() => {
                            // Always disable if current phase is "Data Contract Publish"
                            if (row.currentPhase === "Data Contract Publish") {
                              return (
                                <IconButton disabled size="small" disableRipple  >
                                  {/* <Edit fontSize="small" /> */}
                                  <button className="bg-gray-200 text-gray-400 p-2 text-[12px] border rounded">Edit</button>
                                </IconButton>
                              );
                            }

                            // Always disable if current phase is "In Versioning"
                            if (row.currentPhase === "In Versioning") {
                              return (
                                <IconButton disabled size="small" disableRipple  >
                                  {/* <Edit fontSize="small" /> */}
                                                                    <button className="bg-gray-200 text-[12px] text-gray-400 p-2 border rounded">Edit</button>

                                </IconButton>
                              );
                            }

                            // Define roles and phases
                            const dataEngineerVendorRoles = ['Data Engineer', 'Vendor'];
                            const enabledPhasesForDataEngineerVendor = [
                              'Data Asset Selection',
                              'Column Selection',
                              'Profiling',
                              'Data Quality Rule Configuration'
                            ];

                            if (userRole === 'Admin') {
                              // Admin can access all phases except ones already disabled above
                            } else if (dataEngineerVendorRoles.includes(userRole)) {
                              // For Data Engineer and Vendor: only enable specific phases
                              if (!enabledPhasesForDataEngineerVendor.includes(row.currentPhase)) {
                                return (
                                  <IconButton disabled size="small" disableRipple  >
                                    {/* <Edit fontSize="small" /> */}
                                                                      <button className="bg-gray-200 text-gray-400 p-2 text-[12px] border rounded">Edit</button>

                                  </IconButton>
                                );
                              }
                            }

                            // Enable edit for allowed cases
                            return (
                              <IconButton
                                component={Link}
                                to={`/product-onboarding/${row.productId}`}
                                size="small"
                                sx={{ color: "#bb1ccc" }}
                                disableRipple 
                              >
                                {/* <Edit fontSize="small" /> */}
                                                                  <button className="bg-[#bb1ccc] text-[#fff] p-2 text-[12px] border rounded">Edit</button>

                              </IconButton>
                            );
                          })()}

                          {row.status === "Product Onboarded" || row.currentPhase === "In Versioning" ? (
                       userRole === "Admin" || "Product Owner" ? (
                        <IconButton
                          onClick={() => handleVersioningPopup(row.productId, row.productName, row.currentPhase)}
                          component={Link}
                          size="small"
                          disableRipple 
                          sx={{ color: "green" }}
                        >
                                                            <button className="bg-[#f6ebf2ff] text-[#cd0b7fff] p-2 text-[12px] p-2 border roundede" title={`edit versioning ${row?.version || 1}`}>Edit-V{row?.version || 1}</button> 

                        </IconButton>
                      ) : (
                        <>N/A</>
                      )
                    ) : ( <IconButton disabled size="small" sx={{ opacity: 0.5 }}>
                                                        <button className="bg-[#f6ebf2ff] text-[#cd0b7fff] p-2 text-[12px] p-2 text-[12px] border rounded">Edit-V{row?.version || 1}</button>

                    </IconButton>)  }
                        <IconButton
                          onClick={() => onView && onView(row)}
                          size="small"
                          disableRipple 
                          sx={{ color: "#ca9143" }}
                        >
                          {/* <Visibility fontSize="small" /> */}
                           <button className="bg-blue-100 text-blue-600 p-2 text-[12px] border rounded">View</button>
                        </IconButton>
                        
                        <IconButton
                          onClick={() => handleDeleteClick(row.productId, row.productName)}
                          size="small"
                          disableRipple 
                          sx={{ color: "#d21932ff" }}
                        >
                          {/* <Delete fontSize="small" /> */}
                                                                                            <button className="bg-red-100 text-red-600 p-2 text-[12px] border rounded">Delete</button>

                        </IconButton>
                      </Box>
                    </TableCell>
                  </>
                ) : (
                  <>
                    <TableCell sx={{ fontWeight: 500 }}>{row.name}</TableCell>
                    <TableCell>{row.schema}</TableCell>
                    <TableCell>{row.columns}</TableCell>
                    <TableCell
                      sx={{
                        color: getQualityScoreColor(row.qualityScore),
                        fontWeight: 600,
                      }}
                    >
                      {row.qualityScore}
                    </TableCell>
                    <TableCell>{row.lastUpdated}</TableCell>
                    <TableCell>{row.createdDate}</TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* versioning confirmation Dialog */}
      <Dialog
        open={versioningOpen}
        onClose={handleVersioningCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Confirm Versioning
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to do versioning for "{versioningProduct}"? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleVersioningCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={hanldeVersioning} color="success" variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete the product "{productToDelete?.name}"? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={toast.open} autoHideDuration={3000} onClose={() => setToast({ ...toast, open: false })} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
            <Alert onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} sx={{ width: '100%' }}>
                {toast.message}
              </Alert>
            </Snackbar>
    </>
  );
};

export default MuiDataTable;
